import React from 'react';

import { Link, useNavigate } from 'react-router-dom';
/// Scroll

import { Dropdown } from 'react-bootstrap';

/// Image
import profileImg from '../../../images/profile/avtar.png';

import { connect } from 'react-redux';
import { getProfile } from '../../../store/selectors/AuthSelectors';
import { useAuth } from '../../../context/authContext';

const Header = ({ profile }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const onLogout = async () => {
    logout();
    const nextPath = String(profile?.ssoLoginWith || '').toLowerCase() === 'local' ? '/external-login' : '/login';
    navigate(nextPath, { replace: true });
    window.location.href = nextPath;
  };

  if (!profile) {
    return null;
  }

  const fullName = [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim();
  const greetingName = fullName || profile.displayName || profile.email || 'User';
  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left"></div>
            <ul className="navbar-nav header-right">
              <Dropdown
                as="li"
                className="nav-item dropdown header-profile"
                style={{ border: 'none' }}
              >
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
                  {/* <img src={profileImg} width={20} alt="" /> */}
                  <div className="header-info">
                    <span>
                      Hey, <strong>{greetingName}</strong>
                    </span>
                    <small>{profile.email}</small>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="mt-0 dropdown-menu-end">
                  <Link to="/profile" className="dropdown-item ai-icon">
                    <svg
                      id="icon-user1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ms-2">Profile </span>
                  </Link>
                  <button className="dropdown-item ai-icon" onClick={onLogout}>
                    <svg
                      id="icon-logout"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-danger"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16 17 21 12 16 7" />
                      <line x1={21} y1={12} x2={9} y2={12} />
                    </svg>
                    <span className="ms-2">Logout </span>
                  </button>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    profile: getProfile(state),
  };
};
export default connect(mapStateToProps)(Header);
